import { CalendarEvent } from 'owa-calendar-types';

export default function canReply(item: CalendarEvent): boolean {
    return item.IsMeeting;
}
